export default __webpack_public_path__ + "static/media/euro.6fb3d426.svg";